import React, { useState } from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";

import { AnimatePresence, motion } from "framer-motion";

import InfoDropdown from "../Fold2/InfoDropdown";

const MessagingChallangesSolutions = () => {
  const goToBenefits = () => {
    let element = document.getElementById("benefits");
    element.scrollIntoView({ behavior: "smooth" });
  };

  const dropdownList = [
    {
      id: 0,
      dropdownTitle: "In-App Messaging",
      title: "Ensure Your Messages Are Always Seen",
      text: "Display automatic messages to users across all platforms—mobile or web—whenever they open your app or website. This guarantees direct communication with your customers, ensuring your message is always visible and timely..",
      learnMore: "",
    },
    {
      id: 1,
      dropdownTitle: "In-App Inbox",
      title: "Messages Users Can Check at Their Convenience",
      text: "Allow users to view a collection of messages at their own pace in the in-app inbox. Without interrupting their experience, users can catch up on any messages they may have missed—no spamming, just an organized list of notifications.",
      learnMore: "",
    },
    {
      id: 2,
      dropdownTitle: "User Base Separation",
      title: "Targeted Messaging for New and Existing Users",
      text: "Send automated, tailored messages specifically for new users or existing customers. Messages can be targeted for iOS, Android, or Web users separately, ensuring relevance and engagement across your diverse audience.",
      learnMore: "",
    },
    {
      id: 3,
      dropdownTitle: "Fully Customizable Messages",
      title: "Design Messages Exactly the Way You Want",
      text: "Take control of your messaging with full customization. Use text, images, buttons, hyperlinks, and styling tools to create the perfect message. Preview your content before sending to ensure it looks just right for your audience.",
      learnMore: "",
    },
  ];

  return (
    <FullPageContainer>
      <Container id={"messagingChallangesSolutions"}>
        <Line>
          <TextWrapper>
            <Title>How We Solve Your Messaging Challenges</Title>
            <Subtitle>
              We know how frustrating it can be to manage inconsistent
              messaging. That's why our platform is designed to simplify
              communication, ensuring your alerts reach users seamlessly across
              all platforms.
            </Subtitle>
          </TextWrapper>
        </Line>
        <AnimatePresence>
          <Line>
            <Column>
              {dropdownList.map((item) => (
                <InfoDropdown
                  key={item.id}
                  dropdownTitle={item.dropdownTitle}
                  title={item.title}
                  infoText={item.text}
                  learnMoreClick={item.learnMore}
                />
              ))}
            </Column>
          </Line>
        </AnimatePresence>
      </Container>
    </FullPageContainer>
  );
};

export default MessagingChallangesSolutions;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: 0px 80px 100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 30px;
  max-width: 850px;
  margin: auto;
  @media (max-width: 990px) {
    max-width: unset;
  }
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;

const Subtitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

const CardWrapper = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  justify-content: center;
`;
const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  overflow: hidden;
`;

const Line = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 25px;
  width: 100%;
  overflow: hidden;
  flex-direction: ${(props) => (props.reverse ? "row-reverse" : "initial")};

  @media (max-width: 990px) {
    gap: 10px;
    flex-direction: column;
  }
`;

const Column = styled(motion.div)`
  display: flex;
  flex-direction: column;
    align-items:center;
  width: 100%;
  gap: 16px;
`;
